import t from"./SubjectIndicator.css.js";import{jsx as r}from"react/jsx-runtime";function c(){return r("div",{className:t.subjectIndicator,children:"Subject"})}export{c as default};
